/*!
  Atom, by Koding Themes
  navigation.js
  https://kodingthemes.com
*/

var asideMainEl = document.querySelector('#aside_main');
var asideMain = asideMainEl ? asideMainEl.innerHTML : '';

document.addEventListener("DOMContentLoaded", function () {
  sidebarNavigationLoad();
  sideNavigationOtherMethods();
});

window.addEventListener("resize", function () {
  var sidebarMenu = document.querySelector('.sidebar-menu');
  if (sidebarMenu != null) {
    sidebarMenu.remove();
    var asideMainUpdated = document.querySelector('#aside_main');
    if (asideMainUpdated) asideMainUpdated.innerHTML = asideMain;
  }
  setTimeout(function(){
    sidebarNavigationLoad();
    sideNavigationOtherMethods();
  },100);
});

function sidebarNavigationLoad() {
  var listItemsParent = document.querySelectorAll(
    ".sidebar-menu-list-parent li a"
  );
  var listItemsChild = document.querySelectorAll(".sidebar-menu-list-child li a");

  if (listItemsParent.length > 0) {
    sidebarNavigationExecute(listItemsParent);
  }
  if (listItemsChild.length > 0) {
    sidebarNavigationExecute(listItemsChild);
  }
}

function hideOtherLists(lists) {
  lists.forEach(function (list, i) {
    list.style.display = "none";
  });
}

function resetAnimations(container) {
  if (!container) return;
  var items = container.querySelectorAll('li, .sidebar-menu-back');
  items.forEach(function (item) {
    item.style.animation = 'none';
    item.offsetHeight;
    item.style.animation = '';
  });
}

function sidebarNavigationExecute(listItems) {
  listItems.forEach(function (e) {
    if (window.innerWidth > 1023) {
      e.onmouseover = function () {
        sidebarNavigationMain(listItems, e);
      };
    } else {
      e.onclick = function () {
        sidebarNavigationMain(listItems, e);
      };
    }
    var ele = e.closest("li").querySelector("span.dropdown-toggle");
    if (ele != null && window.innerWidth <= 1023) {
      ele.onclick = function () {
        sidebarNavigationMain(listItems, e);
      };
    }
  });
}

function sidebarNavigationMain(listItems, e) {
  var listChild = document.querySelectorAll(".sidebar-menu-list-child");
  var listGrandChild = document.querySelectorAll(".sidebar-menu-list-grandchild");
  var columnsChild = document.querySelector(".sidebar-menu-columns-child");
  var columnsGrandChild = document.querySelector(".sidebar-menu-columns-grandchild");

  listItems.forEach(function (item) {
    item.closest("li").classList.remove("active-sidebar-menu-item");
  });
  e.closest("li").classList.add("active-sidebar-menu-item");
  var nextColumnItems = e.dataset.nextcolumn;

  if (e.closest(".sidebar-menu-list-parent") && listChild.length > 0) {
    if (listGrandChild.length > 0 && columnsGrandChild) {
      columnsGrandChild.style.width = "0%";
      columnsGrandChild.classList.remove("active-sidebar-nav-column");
      hideOtherLists(listGrandChild);
    }

    if (nextColumnItems) {
      hideOtherLists(listChild);
      var nextColList = document.querySelector("." + nextColumnItems);
      if (nextColList) nextColList.style.display = "block";
      if (columnsChild) {
        resetAnimations(columnsChild);
        columnsChild.style.width = "100%";
        columnsChild.classList.add("active-sidebar-nav-column");
      }
    } else {
      if (columnsChild) {
        columnsChild.style.width = "0%";
        columnsChild.classList.remove("active-sidebar-nav-column");
      }
      hideOtherLists(listChild);
    }
  } else if (e.closest(".sidebar-menu-list-child") && listGrandChild.length > 0) {
    if (nextColumnItems) {
      hideOtherLists(listGrandChild);
      var nextColList = document.querySelector("." + nextColumnItems);
      if (nextColList) nextColList.style.display = "block";
      if (columnsGrandChild) {
        resetAnimations(columnsGrandChild);
        columnsGrandChild.style.width = "100%";
        columnsGrandChild.classList.add("active-sidebar-nav-column");
      }
    } else {
      if (columnsGrandChild) {
        columnsGrandChild.style.width = "0%";
        columnsGrandChild.classList.remove("active-sidebar-nav-column");
      }
      hideOtherLists(listGrandChild);
    }
  }
}
var close = document.querySelector(".close-menu-hamburger");
if(close != null) {
  close.onclick = function (e) {
    sidebarNavigationClose();
  };
}

document.onclick = function (e) {
  var target = e.target;
  if (target.closest(".sidebar-menu-columns") == null) {
    sidebarNavigationClose();
  }
};

function sidebarNavigationClose() {
  var listItemsParent = document.querySelectorAll(
    ".sidebar-menu-list-parent li a"
  );
  var listItemsChild = document.querySelectorAll(".sidebar-menu-list-child li a");
  var columnsChild = document.querySelector(".sidebar-menu-columns-child");
  var columnsGrandChild = document.querySelector(".sidebar-menu-columns-grandchild");

  listItemsParent.forEach(function (e) {
    e.closest("li").classList.remove("active-sidebar-menu-item");
  });
  listItemsChild.forEach(function (e) {
    e.closest("li").classList.remove("active-sidebar-menu-item");
  });

  if (columnsChild) {
    columnsChild.style.width = "0%";
    columnsChild.classList.remove("active-sidebar-nav-column");
  }
  document.querySelectorAll(".sidebar-menu-list-child").forEach(function (e) {
    e.style.display = "none";
  });

  if (columnsGrandChild) {
    columnsGrandChild.style.width = "0%";
    columnsGrandChild.classList.remove("active-sidebar-nav-column");
  }
  document.querySelectorAll(".sidebar-menu-list-grandchild").forEach(function (e) {
    e.style.display = "none";
  });
}

// additional methods
function sideNavigationOtherMethods(){

var open = document.querySelector('.open-menu-hamburger');
  if (open != null) {
    open.onclick = function () {
      keepMenuOpen();
    };
  }

  //keep menu open when clicking inside sidebar
  var mobileMenu = document.querySelector('.js-menu-toggle-mobile');
  if (mobileMenu != null) {
    mobileMenu.onclick = function (e) {
      createOverlay();
      keepMenuOpen();
    };
  }

  //close sidebar menus and overlay
  const handleCloseSidebar = (selector, callback) => {
    const element = document.querySelector(selector);
    if (element) {
      element.onclick = (e) => {
        document.body.removeEventListener('click', closeSidebar);
        keepMenuOpen(); // Optionally createOverlay();

        if (!e.target.closest('.sidebar-menu-columns')) {
          callback();
        }
      };
    }
  };

  //close when overlay clicked on desktop
  handleCloseSidebar('.sidebar-menu', keepMenuClosed);
  //close when desktop close button clicked
  handleCloseSidebar('.close-menu-hamburger', keepMenuClosed);
  //close when mobile close button clicked
  handleCloseSidebar('.js-close-menu', keepMenuClosed);
  //close when overlay clicked on mobile
  handleCloseSidebar('.sidebar-menu-full-width', keepMenuClosed);


  // js for back button
  var back = document.querySelectorAll(".sidebar-menu-back");
  back.forEach(function (btn) {
    btn.onclick = function () {
      var currentCol = btn.closest(".sidebar-menu-columns");
      if (currentCol != null) {
        if (window.innerWidth <= 1023) {
          // On mobile, hide immediately to prevent double-up with the column underneath
          currentCol.style.display = "none";
          currentCol.classList.remove("active-sidebar-nav-column");
          currentCol.style.width = "0%";
          // Reset display after transition so it can be shown again
          setTimeout(function () {
            currentCol.style.display = "";
          }, 50);
        } else {
          currentCol.classList.remove("active-sidebar-nav-column");
          currentCol.style.width = "0%";
        }
      }
    };
  });
}
var closeSidebar = function closeSidebar(e) {
  var container = document.querySelector(".sidebar-menu");
  if (container != null && !container.contains(e.target)) {
    if (document.body.classList.contains('show-sidebar-main')) {
      keepMenuClosed();
    }
  }
};

var keepMenuOpen = function keepMenuOpen() {
  if (!document.body.classList.contains('show-sidebar-main')) {
    if (Shopify.designMode != true) {
      var asideEl = document.querySelector('#aside_main');
      if (asideEl) asideEl.style.transform = 'translate(0px, '+window.pageYOffset+'px)';
    }
    var fullMenu = document.querySelector('.sidebar-menu-full-width');
    var sidebarMenu = fullMenu ? fullMenu.querySelector('.sidebar-menu') : null;
    var parentCol = fullMenu ? fullMenu.querySelector('.sidebar-menu-columns-parent') : null;
    if (fullMenu) {
      fullMenu.classList.remove('hidden');
      // Set closed state inline
      if (sidebarMenu) sidebarMenu.style.transform = 'translateX(-100%)';
      if (parentCol) parentCol.style.width = '0%';
    }
    // Reset item animations so they replay on each open
    resetAnimations(document.querySelector('.sidebar-menu-columns-parent'));
    // Force reflow so browser registers the closed state
    document.body.offsetHeight;
    // Clear inline styles so CSS class transitions take over
    if (sidebarMenu) sidebarMenu.style.transform = '';
    if (parentCol) parentCol.style.width = '';
    document.body.classList.add('show-sidebar-main');
    document.body.classList.add('active');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    var leftSide = document.querySelector('.left-side');
    if (leftSide) leftSide.classList.remove('border-right');
  }
};

var keepMenuClosed = function keepMenuClosed() {
  if (document.body.classList.contains('show-sidebar-main')) {
    document.body.classList.remove('show-sidebar-main');
    document.body.classList.remove('active');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    var leftSide = document.querySelector('.left-side');
    if (leftSide) {
      leftSide.style.background = 'transparent';
      leftSide.classList.add('border-right');
    }
    var menuOverlay = document.querySelector('.menu-popup-background');
    if (menuOverlay) menuOverlay.remove();
    var fullMenu = document.querySelector('.sidebar-menu-full-width');
    if (fullMenu) {
      // Wait for close transition (0.45s) to finish, then reset for next open
      setTimeout(function () {
        fullMenu.classList.add('hidden');
        var sidebarMenu = fullMenu.querySelector('.sidebar-menu');
        if (sidebarMenu) sidebarMenu.style.transform = '';
        var parentCol = fullMenu.querySelector('.sidebar-menu-columns-parent');
        if (parentCol) parentCol.style.width = '';
      }, 500);
    }
  }
};

var createOverlay = function createOverlay() {
  var existing = document.querySelector('.menu-popup-background');
  if (existing) existing.remove();

  var sidebarOverlay = document.createElement('div');
  sidebarOverlay.classList.add('menu-popup-background');
  document.body.appendChild(sidebarOverlay);
};
